import { render, staticRenderFns } from "./mass.vue?vue&type=template&id=95081a54&scoped=true&"
import script from "./mass.vue?vue&type=script&lang=js&"
export * from "./mass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95081a54",
  null
  
)

export default component.exports